import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import BannerCarousel from "../components/BannerCarousel";

function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("http://kolibusiness.com/backend/api-products.php");
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <div style={styles.container}>
      {/* 🔁 Banner Carousel */}
      <BannerCarousel />

      {/* 🌟 Featured Products */}
      <h2 style={styles.title}>Featured Styles</h2>
      <div style={styles.grid}>
        {Array.isArray(products) && products.length > 0 ? (
          products.map(prod => (
            <ProductCard
              key={prod.id}
              product={{
                id: prod.id,
                name: prod.title,
                price: prod.price,
                photo: `http://kolibusiness.com/backend/uploads/${prod.image}`
              }}
            />
          ))
        ) : (
          <p>No products found.</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif"
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px"
  }
};

export default Home;
